
<i *ngIf="isMobile"
  class="tooltip__icon"
  [ngClass]="icon"
  [placement]="position"
  [ngbTooltip]="text"
  [autoClose]="true"
  triggers="click:blur"
></i>

<i *ngIf="!isMobile"
  class="tooltip__icon"
  [ngClass]="icon"
  [placement]="position"
  [ngbTooltip]="text"
></i>
